export const courseRoutes = [
    {
        path: '/course',
        name: 'courseList',
        component: () => 
        /* webpackChunkName: "course" */ import('@/views/course/list/index.vue'),
        meta: {
            title: '课程中心'
        }
    },
    {
        path: '/course/:courseType',
        name: 'courseTypeList',
        component: () => 
        /* webpackChunkName: "course" */ import('@/views/course/list/type.vue'),
        meta: {
            title: '好医术'
        }
    },
    {
        path: '/courseguide/:type/:id',
        name: 'courseGuidePage',
        component: () => 
        /* webpackChunkName: "course" */ import('@/views/course/guide/index.vue'),
        meat: {
            title: '课程详情'
        }
    },
    {
        path: '/course_vip188',
        name: 'courseVip188',
        component: () => 
        /* webpackChunkName: "course" */ import('@/views/course/vip188/index.vue'),
        meat: {
            title: '医董会'
        }
    }
];
